import BookingInfo from 'components/HappeningNonContent/ServiceBooking/BookingInfo/BookingInfo';

export default BookingInfo;
